import { CategoryWithArtistsType, PersonArtistsType } from '@api';

type GetArtistsForCompanyLinkReturnType = CategoryWithArtistsType[];

export const getArtistsForCompanyLink = (
  artists: PersonArtistsType[],
  companyId: string | null
): GetArtistsForCompanyLinkReturnType => {
  return (
    artists.find((artist) => artist.companyId === companyId)
      ?.categoriesWithArtists ?? []
  );
};
